<template>
  <!-- note: this is the inner content that sits INSIDE .card (outer is in parent) -->
  <div class="card-content">
    <div class="label">{{ label }}</div>

    <div class="media-wrap">
      <img :src="image" class="product-img" alt="" />
    </div>

    <div class="meta">
      <div class="title">{{ title }}</div>
      <div class="desc">{{ description }}</div>
      <div class="price">{{ price }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    price: { type: String, default: "" },
    image: { type: String, required: true },
    label: { type: String, default: "info" }
  }
};
</script>

<style scoped>
.card-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  color: #e6eef8;
  text-align: center;
}

/* small label badge */
.label {
  position: absolute;
  top: 10px;
  left: 12px;
  background: rgba(0,0,0,0.35);
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  backdrop-filter: blur(4px);
}

/* media container */
.media-wrap {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2px;
  pointer-events: none; /* so hover events go to parent .card */
}

.product-img {
  width: 76%;
  max-width: 190px;
  height: auto;
  border-radius: 14px;
  object-fit: contain;
  transform: translateZ(40px);
  transition: transform 160ms ease-out, filter 160ms ease-out;
  animation: float 4s ease-in-out infinite;
}

/* meta */
.meta {
  width: 100%;
}
.title {
  font-size: 16px;
  font-weight: 800;
  color: #231a1a;
  margin-top: -6px;
}
.desc {
  font-size: 13px;
  color: rgba(41, 44, 46, 0.85);
  margin-bottom: 0px;
}
.price {
  font-size: 14px;
  /* font-weight: 900; */
  color: #180f0f;
}

/* float animation for the inner image */
@keyframes float {
  0%   { transform: translateZ(40px) translateY(0); }
  50%  { transform: translateZ(46px) translateY(-6px); }
  100% { transform: translateZ(40px) translateY(0); }
}

/* responsive */
@media (max-width: 768px) {
  .card {
    width: 220px !important;
    height: 220px !important;
  }
  .product-img { width: 68%; }
}
</style>
